import React, {Component} from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";
import GridList from "@material-ui/core/GridList";
import GridListTile from "@material-ui/core/GridListTile";

import Logo from "./logo";
import SkeletonLogo from "./skeleton-logo";
import {GAME_SCREEN} from '../../ducks/duck-screen';

const styles = theme => ({
	root: {
		margin: "15px 5px",
	},
	userRiddles: {
		margin: "0 !important",
		paddingBottom: "10px",
	},
	logo: {
		margin: '15px',
	},
	riddleTile:{
		position: "relative",
		"&:before": {
			content:'""',
			display:"block",
			marginTop:"125%"
		},
		"&>div":{
			position: "absolute",
			top: "5px",
			bottom: "5px",
			left: "5px",
			right: "5px",
		}
	},
	"@media (max-width: 420px)": {
		riddleTile:{
			width: '33% !important'
		},
	},
});

class LogosScreen extends Component {
	currentPosition = 0;

	setCurrentPosition = ({ target }) => {
		// console.log("logo setCurrentPosition " + target.scrollTop)
		this.currentPosition = target.scrollTop;
	};

	componentDidMount() {
		const container = document.querySelector('#logos-container').closest("#animation-wrapper");
		container.addEventListener('scroll', this.setCurrentPosition);
		const scrollPosition = this.props.logoListScrollPositions;
		if(scrollPosition){
			container.scrollTop = scrollPosition;
		} else {
			container.scrollTop = 0;
		}
	}

	componentWillUnmount() {
		const container = document.querySelector('#logos-container');
		container.removeEventListener('scroll', this.setCurrentPosition);
		console.log('pozycja logo-screen', this.currentPosition);
		this.props.updateScrollPosition(this.currentPosition, 'logoList')
	}


	render(){

		const { classes,
			push,
			setActiveRiddle,
			userRiddles } = this.props;

		const setActiveRiddleAndChangeScreen = (logo, index) => {
			setActiveRiddle(logo, index);
			push(GAME_SCREEN);
		};

		const renderRiddlesList = userRiddles => {

			return userRiddles.map((logo, index) => {
				return (
					<GridListTile key={`logo-${index}`} cols={1} className={classes.riddleTile}>
						<Logo {...logo} /*completed={logo.solvedDate}*/ onClick={() => {setActiveRiddleAndChangeScreen(logo, index)}} />
					</GridListTile>
				);
			});
		};

		const renderSkeleton = () => {
			return [...Array(20).keys()].map(i => {
				return (
					<GridListTile key={`level-${i}`} cols={1} className={classes.riddleTile}>
						<SkeletonLogo />
					</GridListTile>)
			})
		};

		const areRiddlesDownloaded = userRiddles.length > 0;
		const style = areRiddlesDownloaded ? {} : { overflow: "hidden" };

		return (
			<div className={classes.root} id={"logos-container"} style={style}>
				<GridList cellHeight={"auto"} className={classes.userRiddles} cols={4}  spacing={20} >
					{!areRiddlesDownloaded && renderSkeleton()}
					{areRiddlesDownloaded && renderRiddlesList(userRiddles)}
				</GridList>
			</div>
		);
	}

}

LogosScreen.propTypes = {
	currentRiddleRange: PropTypes.string.isRequired,
	gameType: PropTypes.string.isRequired,
	logoListScrollPositions: PropTypes.number.isRequired,
	isUnlocking: PropTypes.bool.isRequired,

	classes: PropTypes.shape({
		root: PropTypes.string.isRequired,
		userRiddles: PropTypes.string.isRequired,
		logo: PropTypes.string.isRequired,
	}).isRequired,

	userRiddles: PropTypes.array.isRequired,

	push: PropTypes.func.isRequired,
	updateScrollPosition: PropTypes.func.isRequired,
	setActiveRiddle: PropTypes.func.isRequired,
};

export default withStyles(styles)(LogosScreen);
